export default {
  slug: {
    formFieldName: 'slug',
    errors: {
      Required: 'Share link url required',
      Pattern: 'Invalid share link url',
      Unique: 'Share link url already used',
      MaxLength: 'Maximum share link length exceeded',
    },
  },
};
